export default __webpack_public_path__ + "static/media/36.e6c2cd82.png";